import React from 'react';
import courses_banner from '../../../assets/images/main-banner.jpg';

function CoursesBanner() {
    return (
        <div className="main-slider">
            <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src={courses_banner} alt="Main Banner" />
                        <div className="slider-caption">
                            <div className="container-fluid">
                                <div className="row align-items-center">
                                    <div className="col-lg-6">
                                        <div className="slider-box">
                                            <h1>Courses to boost Your Career</h1>
                                            <p>Welcome to our course website, your online entrance to a vast world of study
                                                and knowledge! Our course website is made to give you a fun and practical
                                                way to access information, tools, and interactive materials that are
                                                suitable for your learning requirements.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CoursesBanner;

